import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeCertificateFields {
  title: EntryFieldTypes.Symbol
  colour: EntryFieldTypes.Boolean
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains?: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  internalName?: EntryFieldTypes.Symbol
}

export type TypeCertificateSkeleton = EntrySkeletonType<TypeCertificateFields, 'certificate'>
export type TypeCertificate<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeCertificateSkeleton,
  Modifiers,
  Locales
>

export function isTypeCertificate<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeCertificate<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'certificate'
}

export type TypeCertificateWithoutLinkResolutionResponse = TypeCertificate<'WITHOUT_LINK_RESOLUTION'>
export type TypeCertificateWithoutUnresolvableLinksResponse = TypeCertificate<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeCertificateWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeCertificate<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeCertificateWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeCertificate<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeCertificateWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeCertificate<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
